import { render, staticRenderFns } from "./BudgetBar.vue?vue&type=template&id=cdbdfc12&scoped=true&"
import script from "./BudgetBar.vue?vue&type=script&lang=js&"
export * from "./BudgetBar.vue?vue&type=script&lang=js&"
import style0 from "./BudgetBar.vue?vue&type=style&index=0&id=cdbdfc12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbdfc12",
  null
  
)

export default component.exports